module.exports = __webpack_public_path__ + "img/addNewImage.983e174d.svg";